<template>
  <v-col cols="12" md="6">
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="BookingDate"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="BookingDate"
          label="Drop-off Date"
          :prepend-icon="icon"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="BookingDate" scrollable>
        <div class="flex-grow-1"></div>
        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(BookingDate)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-col>
</template>

<script>
import { mdiCalendar } from "@mdi/js";
export default {
  props: {
    date: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.BookingDate = this.date;
  },
  watch: {
    date: function(val) {
      this.BookingDate = val;
    },
    BookingDate: {
      immediate: true,
      handler(val) {
        this.$emit("change", "BookingDate", val);
      }
    }
  },
  data: () => ({
    BookingDate: new Date().toISOString().substr(0, 10),
    modal: false,
    icon: mdiCalendar
  })
};
</script>